import {Fragment, useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'

const Aside: (props: any) => JSX.Element = (props: any) => {

    const {title, children, setAside} = props;

    useEffect(() => {

    }, []);

    return (
        <Fragment>
            {title &&
                <div className={`absolute left-0 top-0 w-full h-full flex flex-row items-center z-[1025] bg-[rgba(255,255,255,0.8)] cursor-default animate-fadein`} onClick={() => setAside(false)} >
                    <div className="bg-pomegranate-600 text-white drop-shadow p-10 w-[calc(100%-20px)] max-w-[500px] animate-slideinleft">
                        <div className="flex flex-col gap-4">
                            <div className="flex flex-row items-center justify-between">
                                <div className="text-[24px] lg:text-[32px]">{title}</div>
                                <button onClick={() => setAside(false)} className="text-white transition-all hover:text-pomegranate-200" >
                                    <FontAwesomeIcon icon={icon({name: 'xmark'})} className="text-[42px]" />
                                </button>
                            </div>
                            {children &&
                                <div>{children}</div>
                            }
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    );
}

export default Aside;
